import React from 'react'
import { useDispatch } from 'react-redux'
import useTranslation from '../../../hooks/translations';
import { openLiveGame } from '../LiveSlice'
import { SearchItems } from '../types';
import styles from './LiveSearch.module.css'

type Props = {
  searchItems: SearchItems[]
}
const LiveSearch = ({ searchItems }: Props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation('live')
  const searchItemClick = (gameId: number, sportTypeId: number): void => {
    dispatch(openLiveGame({ gameId, sportTypeId }))
  }
  return (
    <div className={styles.searchResults}>
      {searchItems.length ? (
        searchItems.map((item) => (
          <a
            key={`searchResult${item.GameId}`}
            className={styles.searchItem}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
              searchItemClick(item.GameId, item.SportTypeId)
            }
          >
            <span
              className={`${styles.icon} MobSportType${item.SportTypeId}`}
            ></span>
            {`${item.Team1.Text} - ${item.Team2.Text}`}
            <span className={`${styles.championshipTitle}`}>
              {item.ChampionatName.Text}
            </span>
          </a>
        ))
      ) : (
        <div className={styles.noResults}>{t('site.submenu.emptyText')}</div>
      )}
    </div>
  )
}

export default LiveSearch